<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="programOutcome" v-else>

      <b-modal id="cancelDeletePsoConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to proceed
        </h6>
        <div>
          <b-form-group id="input-group-1" label-for="input-1">
            <label class="required-label" for="">Enter a brief explanation of the reason for cancellation of
              deletion (Minimum 10 character):</label>
            <b-form-input id="input-1" v-model="deletePsoModel.reason" type="text"
              placeholder="Enter Reason"></b-form-input>
          </b-form-group>
        </div>
        <div class="buttons">
          <b-button :disabled="(deletePsoModel.reason.length < 10)" size="sm" variant="primary"
            @click="CancelDeletion()">Cancel Deletion</b-button>
          <b-button size="sm" variant="danger" class="ml-2"
            @click="$bvModal.hide('cancelDeletePsoConfirmationModel')">Cancel</b-button>
        </div>
      </b-modal>

      <b-modal id="deletePsoConfirmationModel" hide-header-close hide-footer hide-header centered size="sm">
        <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
          Are you sure you want to delete {{ deletePsoModel.name }}
        </h6>
        <div  :class="['disable-wrapper', { disabled: showOtpBox }]">
        <div>
          <b-form-group id="input-group-1" label-for="input-1">
            <label class="required-label" for="">Type 'DELETE' and press delete button to complete deletion:</label>
            <b-form-input id="input-1" v-model="deletePsoModel.confirmText" type="text"
              placeholder="Enter  DELETE"  :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
          </b-form-group>
        </div>
        <div>
          <b-form-group id="input-group-1" label-for="input-1">
            <label class="required-label" for="">Enter a brief explanation of the reason for deletion (Minimum 10
              character):</label>
            <b-form-input id="input-1" v-model="deletePsoModel.reason" type="text"
              placeholder="Enter Reason"  :class="['disable-wrapper', { disabled: showOtpBox }]"></b-form-input>
          </b-form-group>
        </div>
        <div class="buttons">
          <b-button
            :disabled="(deletePsoModel.confirmText != 'DELETE' || deletePsoModel.reason.length < 10)"
            size="sm" variant="primary" @click="sendOtp()">Delete</b-button>
          <b-button size="sm" variant="danger" class="ml-2"
            @click="$bvModal.hide('deletePsoConfirmationModel')">Cancel</b-button>
        </div>  
        </div>

        <div v-if="showOtpBox" class="mt-3">
          <b-form-group>
            <label class="required-label">Enter OTP to confirm deletion:</label>
            <b-form-input
              v-model="otp"
              placeholder="Enter OTP"
            ></b-form-input>
          </b-form-group>

          <p class="text-danger small">Please contact ezygo support for OTP</p>


           <div class="d-flex align-items-center mt-2">
            <b-button
              variant="success"
              size="sm"
              @click="verifyOtp()">
              Verify OTP & DELETE
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              class="ml-2"
              @click="$bvModal.hide('deletePsoConfirmationModel'); otp=null; showOtpBox=false;">
              Cancel
            </b-button>
          </div>

        </div>

     </b-modal>

      <b-overlay :show="loadpso" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
        <div class="d-flex justify-content-between" style="font-size: 12px" v-if="!outcomeProgram">
          <div class="d-flex align-items-baseline" style="font-size: 12px">
            <b-button variant="info"  size="sm" class="ml-4 mt-2" @click="outcomeProgram = true">Add PSO</b-button>
            <b-button variant="danger" size="sm" class="ml-3" @click="downloadPSOPDF()" >Download PDF</b-button>
          </div>
          <b-button variant="danger"  size="sm" class="ml-4 mt-2" @click="$emit('backToGroups')">Close</b-button>
        </div>

        <b-form @submit.prevent="
          currentspecificOutcome.id
            ? updateProgramSpecificOutcome()
            : addProgramSpecificOutcome()
        " class="mt-4" v-if="outcomeProgram">
          <b-form-group label="Si. No">
            <b-form-input v-model="specificOutcome.si_no" :value="
              currentspecificOutcome.si_no
                ? (specificOutcome.si_no = currentspecificOutcome.si_no)
                : specificOutcome.si_no
            "></b-form-input>
          </b-form-group>
          <b-form-group label="PSO Name">
            <b-form-input v-model="specificOutcome.code" :value="
              currentspecificOutcome.code
                ? (specificOutcome.code = currentspecificOutcome.code)
                : specificOutcome.code
            " :class="{ 'is-invalid': responseErrors.code }"></b-form-input>
            <span class="text-danger" v-if="responseErrors.code">{{
            responseErrors.code[0]
            }}</span>
          </b-form-group>
          <b-form-group label="PSO description">
            <b-form-textarea :class="{ 'is-invalid': responseErrors.outcome }" id="textarea"
              placeholder="Enter description..." rows="3" max-rows="6" v-model="specificOutcome.outcome" :value="
                currentspecificOutcome.outcome
                  ? (specificOutcome.outcome = currentspecificOutcome.outcome)
                  : specificOutcome.outcome
              "></b-form-textarea>
            <span class="text-danger" v-if="responseErrors.outcome">{{
            responseErrors.outcome[0]
            }}</span>
          </b-form-group>

          <b-form-group>
            <b-button variant="danger" size="md" @click="cancel()" :disabled="outcomeBtn.disabled">Cancel</b-button>
            <b-button variant="primary" type="submit" size="md" class="ml-3" :disabled="outcomeBtn.disabled">{{
            outcomeBtn.text }}</b-button>
          </b-form-group>
        </b-form>

        <br />

        <div class="table-responsive" v-if="!outcomeProgram">
          <table class="table table-bordered table-striped" v-if="specificOutcomes.length != 0">
            <thead class="thead-dark">
              <tr>
                <th>Si. No.</th>
                <th>Outcome</th>
                <th>Description</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(pOutcome, pOIndex) in specificOutcomes" :key="pOIndex">
                <td>{{ pOutcome.si_no }}</td>
                <td>{{ pOutcome.code }}
                   <div v-if="(pOutcome.deleted_at != null)">
                      <vue-countdown :time="timeToDeleteIn(pOutcome.deleted_at)" v-slot="{ hours, minutes, seconds }">
                        <b-badge variant="danger" style="white-space: nowrap; margin: 2px;">Delete in
                          {{ hours }}:{{ minutes }}:{{ seconds }}
                        </b-badge><b-link
                          @click="deletePsoModel.id = pOutcome.id; $bvModal.show('cancelDeletePsoConfirmationModel')">
                          <b-badge variant="success">Cancel Deletion</b-badge></b-link>
                      </vue-countdown>
                    </div>
                </td>
                <td>{{ pOutcome.outcome }}</td>
                <td>
                  <span class="text-info btn p-0 m-0" @click="
                    getProgramSpecificOutcome(
                      pOutcome.id,
                      pOutcome.code,
                      pOutcome.outcome,
                      pOutcome.usergroup_id,
                      pOutcome.si_no
                    )
                  "><i class="far fa-edit"></i></span>
                </td>
                <td>
                  <!-- <span class="btn text-danger" @click="$bvModal.show('deletepso' + pOIndex)"><i
                      class="fas fa-trash"></i></span>
                  <b-modal :id="'deletepso' + pOIndex" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
                    hide-footer hide-header centered size="md">
                    <h6 style="font-size: 18px; font-weight: 600" class="text-danger">
                      Deleting this PSO will remove the PSO from CO-PO/PSO
                      mapping and PSO's attached to program exit survey
                      questions. Are you sure you want to proceed?
                    </h6>
                    <div class="buttons">
                      <b-button size="sm" variant="primary" @click="deletePSO(pOutcome.id, pOIndex)">Proceed</b-button>
                      <b-button size="sm" variant="danger" class="ml-2" @click="$bvModal.hide('deletepso' + pOIndex)">
                        Cancel</b-button>
                    </div>
                  </b-modal> -->
                  <span v-if="(enableDeletePsoButton && pOutcome.deleted_at == null)" :id="'usergroupAdmin' + pOIndex"
                        class="btn p-0 m-0 text-info" @click="openDeletePsoModel(pOutcome.id, pOutcome.code )">
                        <i style="color:red;" class="fas fa-trash"></i>
                      </span>  
                </td>
              </tr>
            </tbody>
          </table>
          <p class="text-danger font-weight-bolder" style="font-size: 16px" v-else>
            No Program Specific Outcomes Created Yet!
          </p>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { SOFT_DELETE_RETENTION_MINUTES } from "@/constants";
import axios from "axios";
import moment from 'moment';
import VueCountdown from "@chenfengyuan/vue-countdown";
export default {
  props: ["groupId"],
  async created() {
    await this.getProgramSpecificOutcomes();
  },
  components: {
    VueCountdown,
  },
  data() {
    return {
      otpSent: false,
      otp: "",
      otpVerified: false,
      showOtpBox: false,
      fetchData: false,
      deletePsoModel: { id: null, name: null, confirmText: '', reason: '' },
      loadpso: false,
      specificOutcome: {},
      currentspecificOutcome: {},
      specificOutcomes: [],
      groups: [],
      groupOptions: [],
      outcomeProgram: false,
      outcomeBtn: {
        text: "Submit",
        disabled: false,
      },
      responseErrors: {},
      responseSuccess: {},
      enableDeletePsoButton: true,
      deletedPso: {},
    };
  },
  methods: {
    async sendOtp() {
      if (
        confirm(
          'WARNING: You are going to delete "' +
          name +
          '". PSO data will be deleted from all course lesson plan, CO-PO/PSO mapping, activity, end semester exam data, and all program exit and stakeholder survey questions. Do you still want to proceed?'
        ) == true
      ) 
      {
      this.showOtpBox = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/programmespecificoutcomes/send-delete-otp`;

      await this.$axios.post(url, {
        pso_id: this.deletePsoModel.id
      })
        .then(() => {
          // this.$toast.success("OTP sent to your registered email", {
          //   position: "top",
          //   duration: 5000,
          // });
        })
        .catch(() => {
          this.$toast.error("Failed to send OTP", {
            position: "top",
            duration: 5000,
          });
        });
      }
    },

    async verifyOtp() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/programmespecificoutcomes/verify-delete-otp`;

      await this.$axios.post(url, {
        otp: this.otp,
        pso_id: this.deletePsoModel.id
      })
        .then(() => {
          // this.$toast.success("OTP verified successfully", {
          //   position: "top",
          //   duration: 4000,
          // });

          this.otpVerified = true;
          this.otp = null;
          this.showOtpBox = false;

          this.deletePso();
        })
        .catch(() => {
          this.$toast.error("Invalid OTP", {
            position: "top",
            duration: 5000,
          });
        });
    },
    async CancelDeletion() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/programmespecificoutcomes/${this.deletePsoModel.id}/canceldeletion`;
      this.$axios
        .post(url, { reason: this.deletePsoModel.reason })
        .then(() => {
          this.deletePsoModel = { id: null, name: null, confirmText: '', reason: '' };
          this.getProgramSpecificOutcomes();
        });
    },
    timeToDeleteIn(deleted_at) {
      // Step 1: Add the deletion window to the API response time
      const futureTime = moment.utc(deleted_at, 'YYYY-MM-DD HH:mm:ss').add(SOFT_DELETE_RETENTION_MINUTES, 'minutes');
     
      // Step 2: Get the current UTC time using moment.js
      const currentUTCTime = moment.utc();
      // Step 3: Calculate the difference in seconds
      const timeDifferenceInSeconds = futureTime.diff(currentUTCTime, 'seconds');
      return timeDifferenceInSeconds * 1000;
    },
    openDeletePsoModel(id, name) {
      this.deletePsoModel = { id: id, name: name, confirmText: '', reason: '' };
      this.$bvModal.show("deletePsoConfirmationModel");
    },
    deletePso() {
      let id = this.deletePsoModel.id;
      let name = this.deletePsoModel.name;
      this.enableDeletePsoButton = false;
      this.deletedPso.id = id;
      this.deletedPso.name = name;
      // if (
      //   confirm(
      //     'WARNING: You are going to delete "' +
      //     name +
      //     '". PSO data will be deleted from all course lesson plan, CO-PO/PSO mapping, activity, end semester exam data, and all program exit and stakeholder survey questions. Do you still want to proceed?'
      //   ) == true
      // ) {
        const url =
          this.$store.getters.getAPIKey.mainAPI + `/programmespecificoutcomes/${id}`;
        this.$axios
          .delete(url, {
            data: { reason: this.deletePsoModel.reason },
          })
          .then(() => {
            // console.log(response)
            this.$toast.success(`${name} deletion initiated successfully`, {
              position: "top-right",
              duration: 6000,
            });
            this.enableDeletePsoButton = true;

            this.deletePsoModel = { id: null, name: null, confirmText: '', reason: '' };
            //this.$emit("GroupCreated", true);
            this.getProgramSpecificOutcomes();
          })
          .catch((error) => {
            // console.log(error);
            this.$toast.error(
              `${name} is failed to delete, ` + error.response.data.message,
              {
                position: "top-right",
                duration: 6000,
              }
            );
            error;
            this.enableDeletePsoButton = true;
          });
      // } else {
      //   this.enableDeletePsoButton = true;
      // }
    },
    async downloadPSOPDF() {
      this.loadpso = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/programmespecificoutcomes/report/pdfexport`;
      await this.$axios
        .post(url, { usergroup: this.groupId }, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "programmeSpecificOutcomeReport.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loadpso = false;

          response;
        })
        .catch((error) => {
          this.loadpso = false;
          error;
        });
    },
    async addProgramSpecificOutcome() {
      this.outcomeBtn.text = "Please wait...";
      this.outcomeBtn.disabled = true;
      this.specificOutcome.usergroup_id = await this.groupId;
      const url = this.$store.getters.getAPIKey.programSpecificOutcome;

      axios
        .post(url, this.specificOutcome)
        .then((response) => {
          this.$toast.success(
            this.specificOutcome.code + " is successfully created",
            {
              position: "top",
              duration: 3000,
            }
          );
          this.responseSuccess["created"] = [`Successfully created!`];
          this.clearResponse();

          response;
        })
        .catch((error) => {
          this.responseErrors = error.response.data.errors;
          this.clearResponse();
          error;
        });
    },
    getProgramSpecificOutcomes() {
      this.fetchData = true;
      const url = this.$store.getters.getAPIKey.programSpecificOutcome;
      axios
        .get(url)
        .then((response) => {
          this.specificOutcomes = response.data;
          this.specificOutcomes = this.specificOutcomes.filter((outcome) => {
            return outcome.usergroup_id == this.groupId;
          });
          this.fetchData = false;
          console.log(response);
          response;
        })
        .catch((error) => {
          // this.responseErrors = error.response.data.errors;
          this.fetchData = false;
          error;
        });
    },
    async deletePSO(psoId, poIndex) {
      this.$bvModal.hide("deletepso" + poIndex);
      this.loadpso = true;
      const url =
        this.$store.getters.getAPIKey.programSpecificOutcome + `/${psoId}`;
      await this.$axios
        .delete(url)
        .then((response) => {
          this.$toast.success("PSO Deleted", {
            position: "top",
            duration: 3000,
          });
          this.specificOutcomes.splice(poIndex, 1);
          this.loadpso = false;
          response;
        })
        .catch((error) => {
          this.loadpso = false;
          error;
        });
    },
    getProgramSpecificOutcome(
      pOutcomeId,
      pOutcomeCode,
      pOutcomeDescription,
      pOutcomeGroup,
      pOutcomeSiNo
    ) {
      this.currentspecificOutcome.id = pOutcomeId;
      this.currentspecificOutcome.code = pOutcomeCode;
      this.currentspecificOutcome.outcome = pOutcomeDescription;
      this.currentspecificOutcome.usergroup_id = pOutcomeGroup;
      this.currentspecificOutcome.si_no = pOutcomeSiNo;
      this.outcomeProgram = true;
    },
    updateProgramSpecificOutcome() {
      this.outcomeBtn.text = "Updating...";
      this.outcomeBtn.disabled = true;
      const url =
        this.$store.getters.getAPIKey.programSpecificOutcome +
        `/${this.currentspecificOutcome.id}`;

      axios
        .put(url, this.specificOutcome)
        .then((response) => {
          this.$toast.success(
            this.specificOutcome.code + " is successfully updated",
            {
              position: "top",
              duration: 3000,
            }
          );
          this.responseSuccess["created"] = [`Successfully updated!`];

          this.clearResponse();
          response;
        })
        .catch((error) => {
          // this.responseErrors = error.response.data.errors;
          this.clearResponse();
          error;
        });
    },
    clearResponse() {
      this.outcomeBtn.text = "Submit";
      setTimeout(() => {
        if (this.responseSuccess.created) {
          this.getProgramSpecificOutcomes();
          this.responseSuccess = {};
          this.cancel();
        }

        this.outcomeBtn.disabled = false;
        this.responseErrors = {};
      }, 3000);
    },
    cancel() {
      this.specificOutcome = {};
      this.currentspecificOutcome = {};
      this.outcomeProgram = false;
    },
  },
};
</script>

<style >
.programOutcome table {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
.disable-wrapper.disabled {
  background-color: #e0e0e0; /* gray */
  pointer-events: none;     /* disable all */
  opacity: 0.7;
}

</style>
